/**
 * @generated SignedSource<<75fc6ffd3ccf7dc094dd961656b948ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type portalDropdown_AtlassianHubAppShell$data = {
  readonly portals: {
    readonly portalsList: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "portalDropdown_AtlassianHubAppShell";
};
export type portalDropdown_AtlassianHubAppShell$key = {
  readonly " $data"?: portalDropdown_AtlassianHubAppShell$data;
  readonly " $fragmentSpreads": FragmentRefs<"portalDropdown_AtlassianHubAppShell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "portalDropdown_AtlassianHubAppShell",
  "selections": [
    {
      "concreteType": "HelpCenterPortals",
      "kind": "LinkedField",
      "name": "portals",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterPortal",
          "kind": "LinkedField",
          "name": "portalsList",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
};

(node as any).hash = "9321e563780af8e8cdc6d16d81e1564c";

export default node;
